import * as React from "react";
import Link from "./link";
import FormModal from "./form-modal";

const ButtonLink = ({
  href,
  backgroundColor,
  textColor,
  children,
  button,
  className,
  target,
  variant,
  modal,
  ...props
}) => {
  const ref = React.useRef(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const Component = modal ? "button" : Link;
  const buttonStyle = {};

  if (backgroundColor) {
    buttonStyle.backgroundColor = backgroundColor;
  }

  if (textColor) {
    buttonStyle.color = textColor;
  }

  return (
    <>
      {button === true ? (
        <Component
          className={`${className !== undefined ? className : ""} button-link`}
          data-variant={variant}
          style={buttonStyle}
          type={modal ? "button" : undefined}
          href={modal ? undefined : href}
          target={modal ? undefined : target === true ? "_blank" : "_self"}
          onClick={modal ? openModal : undefined}
          ref={ref}
          {...props}
        >
          {children}
        </Component>
      ) : (
        <Component
          className={`${className !== undefined ? className : ""} link`}
          type={modal ? "button" : undefined}
          href={modal ? undefined : href}
          target={modal ? undefined : target === true ? "_blank" : "_self"}
          onClick={modal ? openModal : undefined}
          ref={ref}
        >
          {children}
        </Component>
      )}
      {modal && (
        <FormModal
          modal={modal}
          isOpen={isModalOpen}
          onClose={closeModal}
          triggerRef={ref}
        />
      )}
    </>
  );
};

export default ButtonLink;
